import React from 'react';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import memberRoutes from '../modules/member/routes'
import bookingRoutes from '../modules/booking/routes'
import cancellationRoutes from '../modules/membership_cancellation/routes'
import MemberContainer from "../modules/member/components/AuthContext";

const AppRoutes = () => {
  const routes = [
    ...memberRoutes,
    ...bookingRoutes,
    ...cancellationRoutes,
  ]

  return ( // only auth routes - MemberContainer
    <MemberContainer>
      <Router>
        <Switch>
          {routes.map(route => (
            <Route path={route.path} component={route.component} key={route.path} exact={route.exact} />
          ))}
        </Switch>
      </Router>
    </MemberContainer>
  );
};

export default AppRoutes;
